import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import commonRootReducer from '../redux/commonRootReducer';
import extranetRootReducer from '../redux/extranetRootReducer';

const initialState = {
    authorizedApps: [],
    activeUser: null,
    authenticatedUser: null,
    locationTitle: '',
    workOrders: [],
};

const store = createStore(
    combineReducers({...commonRootReducer, ...extranetRootReducer}),
    initialState,
    compose(
        applyMiddleware(thunk)
    ),
);

export default store;
